// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'Lynksorg-sub-admin-panel-web-accessToken',
  storageUserDataKeyName: 'Lynksorg-sub-admin-panel-web-portal-userData',
}
